module.exports = __webpack_public_path__ + "img/coin.70c82463.gif";